module.exports = __webpack_public_path__ + "img/nav-thumbnail-write-ups.50bc6f31.png";